"use strict";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";

interface IClickToDialViewHyperLinkProps {
    displayText: string
    providerType: string
    className?: string
    onPhoneNumberClick: () => void
}

function ClickToDialViewHyperLink(props: Readonly<IClickToDialViewHyperLinkProps>): JSX.Element {
    const { getText } = useTranslation();
    const {
        providerType,
        displayText,
        className,
        onPhoneNumberClick
    } = props;
    const title = getText("CallCenter_ClickToDial_HoverTitle", { providerType });

    return (
        <a
            title={title}
            className={className}
            onClick={e => {
                if (onPhoneNumberClick) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    onPhoneNumberClick();
                }
            }}
        >{MyleHelper.ReplaceEmptyString(displayText)}
        </a>
    );
}

export { ClickToDialViewHyperLink };
